  // Оборачивает первое слово в вариантах уровней в span.lvl-word
  (function () {
  function wrapFirstWord() {
    document.querySelectorAll('.quiz-content__options--level .wpcf7-list-item-label').forEach((el) => {
      if (el.querySelector('.lvl-word')) return;

      if (el.closest('.wpcf7-list-item')?.classList.contains('last')) return;

      const text = el.textContent.trim();
      if (!text) return;

      const idx = text.indexOf(' ');
      if (idx === -1) return;

      const first = text.slice(0, idx);
      const rest = text.slice(idx);

      el.innerHTML = `<span class="lvl-word">${first}</span>${rest}`;
    });
  }

  document.addEventListener('DOMContentLoaded', wrapFirstWord);

  document.addEventListener('wpcf7init', wrapFirstWord);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.cf7mls_next, .cf7mls_prev')) {
      setTimeout(wrapFirstWord, 80);
    }
  });
})();